import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Redirect from "../views/redirect.vue"
import SingleItemTest from "@/views/SingleItemTest.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/redirect",
    name: "redirect",
    component: Redirect
  },
  {
    path: "/item",
    name: "item",
    component: SingleItemTest
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
